import { Dispatch, SetStateAction, useState } from 'react'
import { EditWellAdditionalDocuments } from '../../routes/wells/[id]/edit/additional-documents'
import ConfirmTransition from '../confirm-transition'
import { Button, ButtonsContainer, InlineNotification, Modal } from '@msaf/core-react'

interface AGSUploadModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  contentLabel: string
}

export default function AGSUploadModal({ isOpen, setIsOpen, contentLabel }: AGSUploadModalProps) {
  const [isDirty, setIsDirty] = useState<boolean>(false)
  const [triggerSave, setTriggerSave] = useState<boolean>(false)

  return (
    <Modal isOpen={isOpen} contentLabel={contentLabel} onRequestClose={() => {}}>
      <ConfirmTransition isFormDirty={isDirty}>
        <InlineNotification messageType='warning' isDismissable>
          Uploading an AGS file will overwrite existing record entries.
          <br />
          Any invalid or out of range data will be cleared before saving the record.
        </InlineNotification>
        <EditWellAdditionalDocuments
          isAGSUpload
          setIsDirty={setIsDirty}
          triggerSave={triggerSave}
          setTriggerSave={setTriggerSave}
          setIsAGSModalOpen={setIsOpen}
        />
        <ButtonsContainer containerStyle='right'>
          <Button buttonStyle='primary' label='Process AGS File' onClick={() => setTriggerSave(true)} />
          <Button buttonStyle='secondary' label='Cancel' onClick={() => setIsOpen(false)} />
        </ButtonsContainer>
      </ConfirmTransition>
    </Modal>
  )
}
